// @vendors
const Immutable = require('immutable');

// @helpers
const { formatText } = require('core/i18n').i18n;
const { getStore } = require('core/storeHelper');
const { shouldCoherenceControl } = require('mifid/utilities/mifidValidHelper');

// @constants
const {
    BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_EXPERIENCE_MORE_THAN_A_YEAR_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_EXPERIENCE_WITH_KNOWLEDGE_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_STUDY_UNIVERSITARY_ANSWER
} = require('constants/index');

const {
    BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_STUDY_LEVEL,
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_EXPERIENCE,
    BROKER_CONVENIENCE_MIFID_TEST_CONSULT,
} = require('constants/actionTypes');

const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHECK_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CONTINUE_WITH_INCOHERENCES,
} = require('mifid/constants/actionTypes');

// @hardcoded
const getInitialState = () => {
    return Immutable.fromJS({
        study: {
            id: '131',
            orden: '0',
            question: formatText('broker-convenienceMifidTestAnswerStudyLevel'),
            answer: '',
            answers: [
                {
                    id: BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_STUDY_UNIVERSITARY_ANSWER,
                    description: formatText('broker-convenienceMifidTestAnswerStudyLevelUniversitary')
                },
                {
                    id: '133',
                    description: formatText('broker-convenienceMifidTestAnswerStudyLevelSuperiorGrade')
                },
                {
                    id: '134',
                    description: formatText(
                        'broker-convenienceMifidTestAnswerStudyLevelProfessionalFormation'
                    )
                },
                {
                    id: '135',
                    description: formatText('broker-convenienceMifidTestAnswerStudyLevelNone')
                }
            ],
            valid: false
        },
        experience: {
            id: '136',
            orden: '1',
            question: formatText('broker-convenienceMifidTestPreviousExperience'),
            answer: '',
            answers: [
                {
                    id: BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_EXPERIENCE_MORE_THAN_A_YEAR_ANSWER,
                    description: formatText(
                        'broker-convenienceMifidTestAnswerPreviousExperienceMoreThanAYear'
                    )
                },
                {
                    id: BROKER_CONVENIENCE_MIFID_TEST_FIRST_STEP_EXPERIENCE_WITH_KNOWLEDGE_ANSWER,
                    description: formatText(
                        'broker-convenienceMifidTestAnswerPreviousExperienceNoButWithKnowledge'
                    )
                },
                {
                    id: '139',
                    description: formatText('broker-convenienceMifidTestAnswerPreviousExperienceOther')
                }
            ],
            valid: false
        },
        showCoherenceModal: false,
        summaryTitle: formatText('broker-convenienceMifidTestTrainingAndProfessionSummaryTitle'),
        summaryDescription: [],
        valid: false,
        validated: false,
        shouldValidateCoherence: true,
    });
}

function coherenceValidator(immStep) {
    const immPreviousTest = getStore().getState().brokerConsultMiFID.get('questions').toArray();

    const immPreviousEducation = immPreviousTest.find((immQuestion) => {
        return immQuestion.get('id') === '131'
    })
    const immPreviousEducationAnswers = !!immPreviousEducation && immPreviousEducation.getIn(['respuestasArray', 'respuestasArray']);
    const immPreviousEducationAnswerSelected = !!immPreviousEducation &&
        immPreviousEducationAnswers.toArray().find((immAnswer) => {
            return immAnswer.get("seleccionado") === "S";
        });
    const educationAnswers = immStep.getIn(['study','answers']).toArray();
    const educationIsCoherent = !immPreviousEducation || !immPreviousEducationAnswerSelected
        ? true
        : educationAnswers.indexOf(educationAnswers.find((answer)=> answer.get('id') === immPreviousEducationAnswerSelected.get('id'))) >=
            educationAnswers.indexOf(educationAnswers.find((answer)=> answer.get('id') === immStep.getIn(['study', 'answer'])));

    const immPreviousExperience = immPreviousTest.find((immQuestion) => {
        return immQuestion.get('id') === '136'
    })
    const immPreviousExperienceAnswers = !!immPreviousExperience && immPreviousExperience.getIn(['respuestasArray', 'respuestasArray']);
    const immPreviousExperienceAnswerSelected = !!immPreviousExperience && immPreviousExperienceAnswers.toArray()
    .find((immAnswer) => {
        return immAnswer.get("seleccionado") === "S";
    });
    const experienceAnswer = immStep.getIn(['experience','answers']).toArray();
    const experienceIsCoherent = !immPreviousExperience || !immPreviousExperienceAnswerSelected
        ? true
        : experienceAnswer.indexOf(experienceAnswer.find((answer)=> answer.get('id') === immPreviousExperienceAnswerSelected.get('id'))) >=
            experienceAnswer.indexOf(experienceAnswer.find((answer)=> answer.get('id') ===  immStep.getIn(['experience', 'answer'])));
    return educationIsCoherent && experienceIsCoherent;
}
function validateStep(immStep) {
    const studyAnswered = !!immStep.getIn(['study', 'answer']);
    const experienceAnswered = !!immStep.getIn(['experience', 'answer']);
    let valid = studyAnswered && experienceAnswered;
    let coherence = true;
    let shouldValidateCoherence = immStep.get('shouldValidateCoherence');
    if(valid && shouldCoherenceControl() && shouldValidateCoherence) {
        coherence = coherenceValidator(immStep);
        shouldValidateCoherence = !coherence;
    }
    return immStep
        .set('valid', valid && coherence)
        .set('showCoherenceModal', !coherence)
        .set('shouldValidateCoherence', shouldValidateCoherence)
        .set('validated', true)
        .setIn(['study', 'valid'], studyAnswered)
        .setIn(['experience', 'valid'], experienceAnswered);
}

function changeStudyLevel(immState, studyLevel) {
    return immState
        .setIn(['study', 'answer'], studyLevel)
        .set('shouldValidateCoherence', true)
}

function changeExperience(immState, experience) {
    return immState
        .setIn(['experience', 'answer'], experience)
        .set('shouldValidateCoherence', true)
}

function closeIncoherenceModal(immState) {
    return immState.set('showCoherenceModal', false)
}

function continueWithIncoherences(immState) {
    return immState
        .set('valid', true)
        .set('shouldValidateCoherence', false)
        .set('showCoherenceModal', false)
}

function updateSummary(immState) {
    if (!immState.get('valid')) {
        return immState;
    }

    const immStudy = immState.get('study');
    const studyAnswer = immStudy.get('answer');
    const immStudyDescription = immStudy
        .get('answers')
        .find(immAnswer => immAnswer.get('id') === studyAnswer);

    const immExperience = immState.get('experience');
    const experienceAnswer = immExperience.get('answer');
    const immExperienceDescription = immExperience
        .get('answers')
        .find(immAnswer => immAnswer.get('id') === experienceAnswer);

    return immState.set(
        'summaryDescription',
        Immutable.fromJS([
            immStudyDescription.get('description'),
            immExperienceDescription.get('description')
        ])
    );
}

const consult = (questions) => {
    const immState = getInitialState()
    const immQuestions = Immutable.fromJS(questions);

    const studyQuestionId = immState.getIn(['study', 'id']);
    const immStudyQuestion = immQuestions.find(
        immQuestion => immQuestion.get('id') == studyQuestionId
    );
    const immStudyAnswer = immStudyQuestion
        .getIn(['respuestasArray', 'respuestasArray'])
        .find(immAnswer => immAnswer.get('seleccionado') === 'S');

    const experienceQuestionId = immState.getIn(['experience', 'id']);
    const immExperienceQuestion = immQuestions.find(
        immQuestion => immQuestion.get('id') == experienceQuestionId
    );
    const immExperienceAnswer = immExperienceQuestion
        .getIn(['respuestasArray', 'respuestasArray'])
        .find(immAnswer => immAnswer.get('seleccionado') === 'S');

    return immState
        .setIn(['study', 'answer'], immStudyAnswer.get('id'))
        .setIn(['experience', 'answer'], immExperienceAnswer.get('id'));
};



function brokerConvenienceMiFIDTestStep1(state = getInitialState(), action) {
    switch (action.type) {
        case BROKER_CONVENIENCE_MIFID_TEST_CONSULT:
            return consult(action.payload.questions);
        case BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP:
            return updateSummary(validateStep(state));
        case BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_STUDY_LEVEL:
            return changeStudyLevel(state, action.payload.studyLevel);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_EXPERIENCE:
            return changeExperience(state, action.payload.experience);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHECK_INCOHERENCES:
            return closeIncoherenceModal(state);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP1_CONTINUE_WITH_INCOHERENCES:
            return updateSummary(continueWithIncoherences(state));
        default:
            return state;
    }
}

module.exports = brokerConvenienceMiFIDTestStep1;
